export default {
  "content": "<path d=\"M9 5a1 1 0 110 2 1 1 0 010-2z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.5 2a3 3 0 013 3v14a3 3 0 01-3 3h-9a3 3 0 01-3-3V5a3 3 0 013-3h9zm1 7.825a2.99 2.99 0 01-1 .175h-9a2.99 2.99 0 01-1-.175V19a1 1 0 001 1h9a1 1 0 001-1V9.825zM7.5 4a1 1 0 00-1 1v2a1 1 0 001 1h9a1 1 0 001-1V5a1 1 0 00-1-1h-9z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};